import useFetchApi from "@/api/hooks/useFetchApi";
import BreadCrumb from "@/components/BreadCrumb";
import ProductCard from "@/components/Cards/ProductCard";
import Loader from "@/components/Loader/loader";
import React from "react";

const Gallery: React.FC = () => {

    const {
        data,
        isLoading,
        error
    } = useFetchApi({
        url: "/v1/main-module/678764e5d187a284903c5e8f/collection/find?list_related=false&list_referenced=false&limit=0&skip=0",
        service: "CMS_PROC",
        options: {
            refreshInterval: 0,
            revalidateOnFocus: false,
        }
    })

    return (
        <>
            <BreadCrumb title="Galeri" parent="Galeri" child="" />

            <section className="ls section_padding_top_135 section_padding_bottom_90 columns_padding_25">
                <div className="container">
                    <div className="row columns_margin_bottom_40 services-row">
                        {!isLoading && data ? (
                            data?.results?.map((record: any) => (
                                <ProductCard
                                    key={record._id}
                                    data={{
                                        _id: record._id,
                                        title: record.title,
                                        dosya: record.dosya,
                                        content: record.content,
                                        icon: record.icon,
                                        fix_name: record.fix_name,
                                        type: "gallery",
                                        sef_url: record.sef_url
                                    }}
                                    isLoading={false}
                                />
                            ))
                        ) : (
                            <p><Loader /></p>
                        )}
                    </div>
                </div>
            </section>

        </>
    )
}

export default Gallery;